// src/components/PatientPortal/RevokeInvite/RevokeInvite.jsx
import React from "react";
import { Button, Modal, message, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useAuth } from "../../../auth/AuthContext";
import { revokeInvite } from "../utils/api";

const { confirm } = Modal;

const RevokeInvite = ({ inviteId, patientId, reload, setPageLoading }) => {
  const auth = useAuth();

  const handleRevoke = () => {
    confirm({
      title: "Revoke Invite",
      content: `Are you sure you want to revoke invite ${inviteId}?`,
      onOk: async () => {
        setPageLoading(true);
        try {
          await revokeInvite({
            inviteId,
            patientId,
            token: auth.user?.["access_token"],
          });
          message.success("Invite revoked");
          reload();
        } catch (err) {
          message.error(`Failed to revoke invite: ${err.message}`);
        } finally {
          setPageLoading(false);
        }
      },
    });
  };

  return <Tooltip title="Revoke Invite"><Button icon={<DeleteOutlined />} onClick={handleRevoke} size="small" danger /></Tooltip>;
};

export default RevokeInvite;
